<template>
  <div class="market-vcr-buy-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="statistics-box">
      <div class="statistics-item" v-for="(item) in statisticsData" :key="item.title">
        <div class="icon-box">
          <img :src="item.icon" class="img">
        </div>
        <div class="right-box">
          <div class="title">{{ item.title }}</div>
          <div class="amount">{{ item.amount }}</div>
        </div>
      </div>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <template #num="{ row }">{{ row.num }}</template>
      <template #quota="{ row }">{{ row.quota }}</template>
      <template #phone="{ row, scope }">
        <span :key="phone_show">{{ row.phone_show || row.phone }}</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index, 'phone_show', row.userId)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #payAmount="{ row }">{{ row.payAmount }}</template>
      <template #incomeAmount="{ row }">{{ row.incomeAmount }}</template>
      <template #storedCardSource="{ row }">{{ row.storedCardSource }}</template>
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #cardStoreName="{ row }">{{ row.cardStoreName ? row.cardStoreName : '---' }}</template>
      <template #payTime="{ row }">{{ row.payTime ? $moment(row.payTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #refundTime="{ row }">{{ row.refundTime ? $moment(row.refundTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #payType="{ row }">{{ row.payType }}</template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #inviter="{ row, scope }">
        <div v-if="row.inviterType == 'User'">
          <span :key="phone_show1">{{ row.phone_show1 || row.inviter }}</span>
          <auth-button auth="user:phone:read">
            <el-button v-if="row.inviter" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index, 'phone_show1', row.inviterId)">
              {{ row.phone_show1 ? '隐藏' : '查看' }}
            </el-button>
          </auth-button>
        </div>
        <div v-else>
          {{ row.inviter ? row.inviter : '---' }}
        </div>
      </template>
      <template #commissionStr="{ row }">{{ row.commissionStr ? row.commissionStr : '0.00'}}</template>
      <template #commissionSettleType="{ row }">{{ row.commissionSettleType ? row.commissionSettleType : '---'}}</template>
      <template #settledCommission="{ row }">{{ row.settledCommission ? row.settledCommission :  '0.00'}}</template>
      
      <template #secondaryInviter="{ row, scope }">
        <div v-if="row.secondaryInviter">
          <span :key="phone_show2">{{ row.phone_show2 || row.secondaryInviter }}</span>
          <auth-button auth="user:phone:read">
            <el-button v-if="row.secondaryInviter" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index, 'phone_show2', row.secondaryInviterId)">
              {{ row.phone_show2 ? '隐藏' : '查看' }}
            </el-button>
          </auth-button>
        </div>
        <div v-else>
          {{ row.secondaryInviter ? row.secondaryInviter : '---' }}
        </div>
      </template>
      <template #secondaryCommissionStr="{ row }">{{ row.secondaryCommissionStr ? row.secondaryCommissionStr : '0.00'}}</template>
      <template #settledSecondaryCommission="{ row }">{{ row.settledSecondaryCommission ? row.settledSecondaryCommission :  '0.00'}}</template>

      <template #userInviter="{ row, scope }">
        <div v-if="row.userInviter">
          <span :key="phone_show3">{{ row.phone_show3 || row.userInviter }}</span>
          <auth-button auth="user:phone:read">
            <el-button v-if="row.userInviter" class="look-phone-btn"  type="text" @click="onLookPhone(row, scope.$index, 'phone_show3', row.userInviterId)">
              {{ row.phone_show3 ? '隐藏' : '查看' }}
            </el-button>
          </auth-button>
        </div>
        <div v-else>
          {{ row.userInviter ? row.userInviter : '---' }}
        </div>
      </template>
      <template #userInviterCommissionStr="{ row }">{{ row.userInviterCommissionStr ? row.userInviterCommissionStr : '0.00'}}</template>
      <template #settledUserInviterCommission="{ row }">{{ row.settledUserInviterCommission ? row.settledUserInviterCommission :  '0.00'}}</template>
    </Table>
  </div>
</template>

<script>
import aes from '@/common/aes.js'
import { downFile } from "@/utils";
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getUserPhone } from '@/api/common'
import { api_postBuyCardRecordList, api_postBuyCardRecordExport } from '@/api/market'

export default {
  name: "buyCardRecord",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "支付时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "储值卡名称",
          placeholder: "请选择储值卡名称",
          type: "input",
          key: "name",
        },
        {
          label: "会员手机号",
          placeholder: "请输入会员手机号",
          type: "input",
          key: "phone",
        },
        {
          label: "订单来源",
          placeholder: "请选择订单来源",
          type: "select",
          multiple: false,
          key: "source",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {},
      phone_show: false,
      phone_show1: false,
      phone_show2: false,
      phone_show3: false,
      tableThData: [
        { prop: "name", label: "储值卡名称", minWidth: "180", },
        { prop: "num", label: "购卡数量", minWidth: "80", },
        { prop: "quota", label: "额度(元)", minWidth: "120", },
        { prop: "phone", label: "会员手机号", minWidth: "220", },
        { prop: "payAmount", label: "实付金额(元)", minWidth: "120", },
        { prop: "incomeAmount", label: "结算金额(元)", minWidth: "120", },
        { prop: "storedCardSource", label: "数据来源", minWidth: "100", },
        { prop: "cardStoreName", label: "购卡店铺名称", minWidth: "180", },
        { prop: "paymentOrderId", label: "交易订单号", minWidth: "160", },
        { prop: "payTime", label: "支付时间", minWidth: "180", },
        { prop: "refundTime", label: "退款时间", minWidth: "180", },
        { prop: "payType", label: "支付类型", minWidth: "120", },
        { prop: "source", label: "订单来源", minWidth: "150", },
        { prop: "inviter", label: "一级分佣对象", minWidth: "220", },
        { prop: "commissionStr", label: "应发佣金金额（元）", minWidth: "150", },
        { prop: "commissionSettleType", label: "佣金结算方式", minWidth: "120", },
        { prop: "settledCommission", label: "实发佣金金额（元）", minWidth: "150", },
        { prop: "secondaryInviter", label: "二级分佣对象", minWidth: "220", },
        { prop: "secondaryCommissionStr", label: "应发二级佣金金额（元）", minWidth: "180", },
        { prop: "settledSecondaryCommission", label: "实发二级佣金金额（元）", minWidth: "180", },
        { prop: "userInviter", label: "直接邀请人", minWidth: "220", },
        { prop: "userInviterCommissionStr", label: "应发邀请人佣金（元）", minWidth: "180", },
        { prop: "settledUserInviterCommission", label: "实发邀请人佣金（元）", minWidth: "180", },
      ],
      statisticsData: [
        {
          key: 'totalBuyAmount',
          title: '累积交易（元）',
          icon: require("@/assets/market_images/statistics-icon01.png"),
          amount: '-'
        },
        {
          key: 'totalRefundAmount',
          title: '累积退款（元）',
          icon: require("@/assets/market_images/statistics-icon02.png"),
          amount: '-'
        },
        {
          key: 'totalNumber',
          title: '累积售卡数量（张）',
          icon: require("@/assets/market_images/statistics-icon07.png"),
          amount: '-'
        },
        {
          key: 'totalRefundNumber',
          title: '累积退卡数量（张）',
          icon: require("@/assets/market_images/statistics-icon06.png"),
          amount: '-'
        },
        {
          key: 'todayBuyAmount',
          title: '今日交易（元）',
          icon: require("@/assets/market_images/statistics-icon03.png"),
          amount: '-'
        },
        {
          key: 'todayRefundAmount',
          title: '今日退款（元）',
          icon: require("@/assets/market_images/statistics-icon04.png"),
          amount: '-'
        },
      ],
      exportLoading: false,
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      try {
        let params = {
          ...this.form,
          offset: this.offset,
          limit: this.limit,
        }
        this.$router.push({query: params})
        params.createdFrom = this.form.time ? this.form.time[0] : null
        params.createdTo = this.form.time ? this.form.time[1] : null
        delete params.time
        const { page, storedCardTodayTradeVO, storedCardTotalTradeVO } = await api_postBuyCardRecordList(params)
        console.log('page: ', page);
        this.tableTrData = page.list || []
        this.total = page.count
        this.setStatisticsData(storedCardTodayTradeVO, storedCardTotalTradeVO)
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    // 统计数据赋值
    setStatisticsData(today={}, total={}) {
      const data = {...today, ...total}
      this.statisticsData.forEach(item => {
        item.amount = typeof data[item.key] == 'number' ? data[item.key] : '-'
      })
    },

    // 导出
    async onExport() {
      this.exportLoading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.form.time && (params.createdFrom = this.form.time ? this.form.time[0] : null)
      this.form.time && (params.createdTo = this.form.time ? this.form.time[1] : null)
      delete params.time
      let res = await api_postBuyCardRecordExport(params)
      console.log(res)
      downFile(res)
      this.exportLoading = false
    },

    // 点击查看手机号
    async onLookPhone(row, index, key, userId) {
      try {
        if (row[key]) {
          delete this.tableTrData[index][key]
        } else {
          const {phone} = await api_getUserPhone({id: userId})
          this.tableTrData[index][key] = aes.decrypt(phone)
        }
        this[key] = !this[key]
      } catch (error) {
        console.log('error: ', error);
      }
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-vcr-buy-index {
  width: 100%;
  padding: 0;
  box-sizing: border-box;

  .el-button {
    min-width: 80px !important;
  }

  .statistics-box {
    padding: 10px 0;
    display: flex;
    border-bottom: 1px solid #cccccc80;
    overflow-x: auto;

    .statistics-item {
      min-width: 230px;
      height: 80px;
      border-right: 1px solid #cccccc80;
      display: flex;
      align-items: center;

      .icon-box {
        margin-left: 40px;
        width: 40px;
        height: 40px;

        .img {
          width: 100%;
          height: 100%;
        }
      }

      .right-box {
        margin-left: 10px;

        .title {
          font-size: 12px;
          color: #666;
          margin-bottom: 10px;
        }

        .amount {
          font-size: 20px;
          font-weight: 500;
          color: #333;
        }
      }

      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
